module.exports = __webpack_public_path__ + "static/media/info.e9e77ffa.svg";